import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "error",
    "generateButton",
    "generateLabel",
    "idle",
    "link",
    "loading",
    "ready",
    "submitButton",
  ];
  static values = { previewUrl: String, statusUrl: String };

  connect() {
    this.refreshStatus = this.refreshStatus.bind(this);
    window.addEventListener("focus", this.refreshStatus);
  }

  disconnect() {
    window.removeEventListener("focus", this.refreshStatus);
    window.clearTimeout(this.statusTimeout);
  }

  async generate() {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content;

    this.generateButtonTarget.disabled = true;
    this.submitButtonTarget.disabled = true;
    this.generateLabelTarget.textContent = "Generating preview…";
    this.showState("loading");

    try {
      const response = await fetch(this.previewUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) throw new Error("Preview generation failed");

      const data = await response.json();
      if (!data.preview_url) throw new Error("Preview URL missing");

      this.linkTarget.href = data.preview_url;
      this.generateLabelTarget.textContent = "Regenerate preview";
      this.showState("ready");
    } catch (error) {
      console.error("Failed to generate print preview:", error);
      this.generateLabelTarget.textContent = "Try again";
      this.showState("error");
    } finally {
      this.generateButtonTarget.disabled = false;
    }
  }

  previewOpened() {
    window.clearTimeout(this.statusTimeout);
    this.statusTimeout = window.setTimeout(this.refreshStatus, 1000);
  }

  async refreshStatus() {
    const response = await fetch(this.statusUrlValue, { headers: { Accept: "application/json" } });
    if (!response.ok) return;

    const data = await response.json();
    this.submitButtonTarget.disabled = !data.viewed;
  }

  showState(state) {
    const states = {
      error: this.errorTarget,
      idle: this.idleTarget,
      loading: this.loadingTarget,
      ready: this.readyTarget,
    };

    Object.entries(states).forEach(([name, target]) => {
      target.classList.toggle("hidden", name !== state);
    });
  }
}
